import type { Sides } from "@project/emerge-types";
import * as THREE from "three";
import type { EndpointType } from "../enum/EndpointType";
import type { CornerInfos } from "./CornerInfos";

interface EndpointInfosOptions {
  group: string;
  isOriginal: boolean;
  outerPos: THREE.Vector3;
  pos: THREE.Vector3;
  sides: Sides[];
}

// describes a endpoint of an edge
export class EndpointInfos {
  get center() {
    const result = new THREE.Vector3();
    result.addVectors(this.innerPos, this.outerPos);
    result.multiplyScalar(0.5);
    return result;
  }
  public isOriginal: boolean;
  public innerPos: THREE.Vector3;
  public originalPos: THREE.Vector3;
  public outerPos: THREE.Vector3;
  public originalOuterPos: THREE.Vector3;
  public corner: CornerInfos | null;
  public cutsAffectedBy: string[] = [];
  public get type(): EndpointType {
    const axes: Array<"x" | "y" | "z"> = ["x", "y", "z"];
    const changedAxes = axes.filter(
      (axis) => this.innerPos[axis] !== this.originalPos[axis],
    );
    return changedAxes.length as EndpointType;
  }
  // which sides the corner touches
  public sides: Sides[];
  constructor(options: EndpointInfosOptions) {
    this.isOriginal = options.isOriginal;
    this.innerPos = options.pos;
    this.originalPos = options.pos.clone();
    this.outerPos = options.outerPos;
    this.originalOuterPos = options.outerPos.clone();
    this.sides = options.sides;
    this.corner = null;
  }
}
